import useTestId from '@ori/testid-generator';
import { RatingCount, Root, StarRating } from "./styles";
import { RATING } from "../../constants";
import { useProduct } from "../../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Rating = function Rating() {
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useProduct = useProduct(),
    code = _useProduct.code,
    hideRating = _useProduct.hideRating,
    rating = _useProduct.rating,
    ratingCount = _useProduct.ratingCount;
  if (hideRating) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(StarRating, {
      value: rating,
      max: 5,
      showTextRating: false,
      "data-testid": "".concat(getTestId(RATING), "-").concat(code)
    }), /*#__PURE__*/_jsxs(RatingCount, {
      children: ["(", ratingCount, ")"]
    })]
  });
};
//# sourceMappingURL=Rating.js.map